import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DeckDetailPage } from '@/features/decks/DeckDetailPage.js';
import { ensureDecksEnabled } from '@/features/decks/guard.js';
import { deckQueryOptions } from '@/lib/api/decks.js';

export const Route = createFileRoute('/decks/$id')({
  component: DeckDetailRoute,
  beforeLoad: () => ensureDecksEnabled(),
});

function DeckDetailRoute(): JSX.Element {
  const { id } = useParams({ from: '/decks/$id' });
  const { data: detail, isLoading, isError } = useQuery(deckQueryOptions(id));
  return (
    <DeckDetailPage detail={detail} isLoading={isLoading} isError={isError} />
  );
}
